import { Link as JoyLink, LinkProps as JoyLinkProps } from '@mui/joy';
import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby';
import React, { FC } from 'react';

interface LinkProps<TState = {}> extends JoyLinkProps, Pick<GatsbyLinkProps<TState>, 'to'> {}

const Link: FC<LinkProps> = (props) => <JoyLink component={GatsbyLink} {...props} />;

export default Link;
